import { apiService, setAuthToken } from './api';
import { AuthLoginRequest, AuthLoginResponse } from '../types/api';

class AuthService {
  async login(payload: AuthLoginRequest): Promise<AuthLoginResponse> {
    const response = await apiService.post<AuthLoginResponse>('/auth/login', payload);
    if (response?.token) {
      setAuthToken(response.token);
    }
    return response;
  }

  logout() {
    setAuthToken(undefined);
  }
}

export const authService = new AuthService();
